var UpdateType = {
    CONTENT : 0,
    PAGED_RECORD_ORDERED : 1,
    PAGED_STRING_ORDERED : 2,
    PAGED_RECORD_UNORDERED : 3,
    PAGED_STRING_UNORDERED : 4
};

var UpdateAction = {
    UPDATE : 0,
    REPLACE : 1
};

var Update = function(data, type, action) {
    this.data = data;
    this.type =  type !== undefined ? type : UpdateType.CONTENT;
    this.action = action !== undefined ? action : UpdateAction.UPDATE;
};

module.exports = {
    Type : UpdateType,
    Update : Update
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/update/update.js
// module id = 452
// module chunks = 1